import {Component} from "react";
import Glob from "../../../libs/Glob.mjs";
import appLib from "../../../libs/appLib.mjs";
import "./BachecaAdmin.css";
import HamburgerArea from "../../../controls/HamburgerArea.mjs";
import {Button, ButtonGroup} from "reactstrap";
import AppDislikeIcon from "../../../media/assets/AppDislikeIcon.mjs";
import AdminSegnalazioni from "./AdminSegnalazioni.mjs";
import UserIcon from "../../../media/assets/UserIcon.mjs";
import AdminUtenti from "./AdminUtenti.mjs";
import AppAboutIcon from "../../../media/assets/AppAboutIcon.mjs";
import TextLabel from "../../../controls/TextLabel.mjs";
import AdminInfoDati from "./AdminInfoDati.mjs";

const prefix = "BachecaAdmin";

const BachecaAdmin = class extends Component {
	constructor(props) {
		super(props);
		const u = appLib.currentUser();
		this.state = {
			user: u,
			canAdmin: (u?.admin||u?.moderator),
			pane: 'Segnalazioni',
			icon: <AppDislikeIcon />
		}
		this.uid = Glob.generateUid(prefix);
		this.selectPane  = this.selectPane.bind(this);
	}
	componentDidMount() {
		Glob.register('currentUser', ui => {
			this.setState({user: ui, canAdmin: (ui?.admin||ui?.moderator)});
		}, this.uid);
	}
	componentWillUnmount() {
		Glob.deregister(this.uid);
	}
	selectPane(p, icon) {
		this.setState({manualChoice: true, pane: p, icon: icon ?? this.state.icon});
	}
	render() {
		if ( ! this.state.canAdmin ) return null;
		return (
			<div className={prefix} id={this.uid}>
				<div className={"toolbar"}>
					{ this.state.icon }
					<span>
						<TextLabel value={this.state.pane} />
					</span>
					<HamburgerArea
						align={"end"}
					>
						<ButtonGroup
							className={"btn-icon"}
							vertical={true}
						>
							<Button
								color={"warning"}
								disabled={ this.state.pane === 'Segnalazioni' }
								onClick={() => this.selectPane("Segnalazioni", <AppDislikeIcon />) }
							>
								<b><TextLabel value={"Segnalazioni"} /></b>
								<i><AppDislikeIcon /></i>
							</Button>
							<Button
								color={"primary"}
								disabled={ this.state.pane === 'Utenti' }
								onClick={() => this.selectPane("Utenti", <UserIcon />) }
							>
								<b><TextLabel value={"Utenti"} /></b>
								<i><UserIcon /></i>
							</Button>
							<Button
								color={"success"}
								disabled={ this.state.pane === 'About' }
								onClick={() => this.selectPane( "About", <AppAboutIcon /> ) }
							>
								<b><TextLabel value={"About"} /></b>
								<i><AppAboutIcon /></i>
							</Button>
						</ButtonGroup>
					</HamburgerArea>
				</div>
				{ this.state.pane === 'Segnalazioni' && (
					<AdminSegnalazioni
						user={this.state.user}
						ifEmpty={ ()=>{ if ( ! this.state.manualChoice ) this.setState({ pane: "Utenti", icon: <UserIcon /> }) ; } }
					/>
				)}
				{ this.state.pane === 'Utenti' && <AdminUtenti user={this.state.user} /> }
				{ this.state.pane === 'About' && <AdminInfoDati /> }
			</div>
		)
	}
}

export default BachecaAdmin;